import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Activities from './pages/Activities';
import About from './pages/About';
import Contact from './pages/Contact';
import Emendas from './pages/Emendas';
import EmendaDetalhes from './pages/EmendaDetalhes';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import { AdminPanel } from './components/admin/AdminPanel';
import { AuthProvider } from './contexts/AuthContext';
import CookieConsent from './components/CookieConsent';
import { ContentProvider } from './context/ContentContext';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <Router>
          <AppContent />
        </Router>
      </ContentProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isEmendaDetalhes = location.pathname.startsWith('/emendas/') && location.pathname.split('/').length > 2;

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 flex flex-col">
      <ScrollToTop />
      {!isAdmin && !isEmendaDetalhes && <Navbar />}
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/emendas" element={<Emendas />} />
          <Route path="/emendas/:id" element={<EmendaDetalhes />} />
          <Route path="/atividades" element={<Activities />} />
          <Route path="/sobre-nos" element={<About />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos-de-uso" element={<TermsOfUse />} />
          <Route path="/admin/*" element={<AdminPanel />} />
        </Routes>
      </div>
      {!isAdmin && !isEmendaDetalhes && <Footer />}
      {!isAdmin && !isEmendaDetalhes && <CookieConsent />}
    </div>
  );
}
